
import React, { useEffect } from 'react'

const ErrorPage = (props) => {

    useEffect(() => {
       console.log("error page component did mount fired")
       window.location="/CB_500"
    }, [])



    return (
        <div className={"error-page"}>
        </div>
    )
}

export default ErrorPage
